import React from 'react';
import { FormattedDate } from 'react-intl';

import t from 'modules/i18n/intl';
import validateEmailAddress from 'util/email';

import { ExpiringDateSelectOption } from './types';
import { defaultFormState } from '../constants/constants';

export function generateMonthList() {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 2;
  const endYear = currentYear + 2;

  const monthList: Array<ExpiringDateSelectOption> = [{ label: t('mac.licenses.expiring.in') }];

  for (let year = startYear; year <= endYear; year += 1) {
    for (let month = 0; month < 12; month += 1) {
      monthList.push({
        label: <FormattedDate value={new Date(year, month)} year="numeric" month="short" />,
        value: new Date(year, month),
      });
    }
  }

  return monthList;
}

export const getCountryByCountryName = (allCountries, countryName) => {
  const country = allCountries?.find(
    ({ displayName }) => displayName?.toLowerCase() === countryName?.toLowerCase(),
  );
  return (
    country && {
      label: country.displayName,
      value: country.countryIsoCode,
    }
  );
};

export const getStateOptionFromStates = (states, stateCode) => {
  const seek = stateCode?.toUpperCase().startsWith('TH-') ? stateCode.split('-')[1] : stateCode;
  const state = states.find(({ value }) => value === seek) || defaultFormState.state;
  return (
    state && {
      label: state.label,
      value: state.value,
    }
  );
};

const validateEmailDomain = (email) => {
  return !/@(gmail|hotmail|outlook)\.com$/.test(email);
};

const validateNewContactEmail = (emailValidator, domainValidator) => (email) => {
  return emailValidator(email) && domainValidator(email);
};

export const isValidEmail = validateNewContactEmail(validateEmailAddress, validateEmailDomain);

export const removeTimezone = (dateString: string): string => {
  const timezoneRegex = /([+-]\d{4})$/;
  return dateString ? dateString.replace(timezoneRegex, '') : dateString;
};
